import React from "react";
import { Link } from "react-router-dom";

const DataDeletion: React.FC = () => {
    return (
        <main className="min-h-screen bg-gray-50 text-gray-800 flex items-center justify-center p-6">
            <section className="bg-white max-w-3xl w-full rounded-2xl shadow-sm border border-gray-200 p-8">
                <h1 className="text-3xl font-bold text-indigo-600 mb-4">
                    Data Deletion Instructions
                </h1>

                <p className="text-gray-700 mb-4 leading-relaxed">
                    At <strong>SecureID Technologies LLC</strong>, we respect your right to
                    control your personal information. If you have joined the
                    <span className="text-indigo-600 font-medium"> SecureID Social Wall </span>
                    using your Google or Facebook account and wish to have your data removed,
                    please follow the steps below:
                </p>

                <ol className="list-decimal list-inside space-y-3 mb-6 text-gray-700">
                    <li>
                        Send an email to{" "}
                        <a
                            href="mailto:info@secureidtechnologies.com"
                            className="text-indigo-600 hover:underline font-medium"
                        >
                            info@secureid.com
                        </a>{" "}
                        using the same address you used to sign in.
                    </li>
                    <li>
                        Use the subject line <strong>"Data Deletion Request"</strong>.
                    </li>
                    <li>
                        We will remove your profile, posts, comments, and likes within{" "}
                        <strong>7 business days</strong>.
                    </li>
                </ol>

                <p className="text-gray-700 mb-4">
                    For more details about how we handle your information, please review our{" "}
                    <Link
                        to="/privacy"
                        className="text-indigo-600 hover:underline font-medium"
                    >
                        Privacy Policy
                    </Link>{" "}
                    or our{" "}
                    <Link
                        to="/terms"
                        className="text-indigo-600 hover:underline font-medium"
                    >
                        Terms of Service
                    </Link>
                    .
                </p>

                <p className="text-sm text-gray-500 mt-6">
                    <em>Last updated: October 2025</em>
                </p>
            </section>
        </main>
    );
};

export default DataDeletion;
